import axios from "axios";
import gql from "graphql-tag";

const {
  VUE_APP_GRAPH_ENDPOINT,
  VUE_APP_SP_FOLDER_ROOT,
  VUE_APP_SP_SITE_ID
} = process.env;

const mainFolderName = "Main";

const getMsToken = async () => {
  // return localStorage.getItem("i24h_aad_office");

  let token;
  try {
    const result = await this.$apollo.query({
      query: gql`
        query {
          refreshMsToken
        }
      `
    });
    token = result?.data?.refreshMsToken;
  } catch (e) {
    console.error(e);
  }
  return token;
};

const uploadFnc = async (msTokenStore, formId, formCode, file) => {
  // const PREFIX_URL = `${VUE_APP_GRAPH_ENDPOINT}${VUE_APP_SP_SITE_ID}/drive/root:/${VUE_APP_SP_FOLDER_ROOT}/${formCode}-${formId}/${mainFolderName}`;
  const PREFIX_URL = `${VUE_APP_GRAPH_ENDPOINT}${VUE_APP_SP_SITE_ID}/drive/root:/${VUE_APP_SP_FOLDER_ROOT}/${formCode}-${formId}`;

  const msToken = msTokenStore ? msTokenStore : await getMsToken();

  if (msToken) {
    const createUploadSessionUrl = `${PREFIX_URL}/${file.name}:/createUploadSession`;
    try {
      const createdUploadSession = await axios({
        method: "POST",
        url: createUploadSessionUrl,
        data: {
          item: {
            "@microsoft.graph.conflictBehavior": "rename"
          },
          fileSystemInfo: { "@odata.type": "microsoft.graph.fileSystemInfo" },
          name: file.name
        },
        headers: {
          Authorization: "Bearer " + msToken,
          "Content-Type": "application/json"
        }
      });

      const { uploadUrl } = createdUploadSession.data;

      return axios({
        method: "PUT",
        url: uploadUrl,
        data: file,
        headers: {
          Authorization: "Bearer " + msToken,
          "Content-Range": `bytes 0-${+file.size - 1}/${file.size}`
        }
      });
    } catch (error) {
      Promise.reject(error);
    }
  } else {
    const error = new Error("Không có MS Token!");
    Promise.reject(error);
  }
};

export default uploadFnc;
